import styled from 'styled-components';
import { RowTable } from '../../../../func/components/Table';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { useReportContext } from '../../../../context/DetailContext';

const BasicInfo = ({ data }: any) => {
  const { type } = useReportContext();

  const rendingData = [
    { key: '물건종별', value: data.category },
    { key: '감정가', value: `${ReportFormatNumber(data.appraisalPrice)}` },
    { key: '최저가', value: `${ReportFormatNumber(data.minimumPrice)}` },
    { key: '보증금', value: `${ReportFormatNumber(data.deposit)}` },
    {
      key: '토지면적',
      value:
        data.landArea && data.landAreaPyoeng
          ? `${NumberwithComma(
              data.landArea,
            )}m² (${NumberwithComma(data.landAreaPyoeng)}평)`
          : `${data.landArea}m²`,
    },
    {
      key: '건물면적',
      value:
        data.buildingArea && data.buildingAreaPyoeng
          ? `${NumberwithComma(
              data.buildingArea,
            )}m² (${NumberwithComma(data.buildingAreaPyoeng)}평)`
          : '',
    },
    { key: '매각물건', value: data.saleItem },
    { key: '소유자', value: data.owner },
  ];
  const PAuctionRendingData = [
    { key: '처분방식', value: data.saleItem },
    { key: '입찰방식', value: data.bidMethod },
    { key: '자산구분', value: data.assetClass },
    { key: '입찰기간', value: data.biddate },
    { key: '용도', value: data.category },
    { key: '유찰횟수', value: data.bidCount },
    {
      key: '토지면적',
      value:
        data.landArea && data.landAreaPyoeng
          ? `${NumberwithComma(
              data.landArea,
            )}m² (${NumberwithComma(data.landAreaPyoeng)}평)`
          : NumberwithComma(data.landArea),
    },
    {
      key: '건물면적',
      value:
        data.buildingArea && data.buildingAreaPyoeng
          ? `${NumberwithComma(
              data.buildingArea,
            )}m² (${NumberwithComma(data.buildingAreaPyoeng)}평)`
          : '',
    },
    { key: '집행기관', value: data.courtName },
    { key: '담당자정보', value: data.manager },
    { key: '감정가', value: `${ReportFormatNumber(data.appraisalPrice)}` },
    { key: '최저입찰가', value: `${ReportFormatNumber(data.minimumPrice)}` },
  ];

  const RenderData = () => {
    if (type === 'a') {
      return rendingData;
    } else {
      return PAuctionRendingData;
    }
  };

  return (
    <Container id="물건기본정보">
      <div>물건기본정보</div>
      <RowTable data={RenderData()} titleWidth={110} />
    </Container>
  );
};

export default BasicInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;
